import { useId, type ReactNode } from 'react';
import { cn } from '@shared/utils';
import styles from './radio.module.css';

type RadioProps = {
  className?: string;
  name?: string;
  checked?: boolean;
  value?: string | number;
  onChange?: (value: string | number) => void;
  onClick?: (value: boolean) => void;
  children?: ReactNode;
};

export const Radio = (props: RadioProps) => {
  const id = useId();

  return (
    <div className={cn(styles.radio, props.className)}>
      <input
        id={id}
        className={cn('hidden', styles.input)}
        type='radio'
        name={props.name}
        checked={props.checked}
        value={props.value}
        onChange={(e) => props.onChange?.(e.target.value)}
      />
      <label
        htmlFor={id}
        className={cn(
          'relative flex w-fit cursor-pointer gap-2 select-none before:h-[27px] before:w-[27px] before:rounded-full before:border before:border-[#000] before:bg-[#fff] after:absolute after:top-[6px] after:left-[6px] after:hidden after:h-[15px] after:w-[15px] after:rounded-full after:bg-[#e5c496]',
          styles.label,
        )}
        onClick={() => props.onClick?.(!props.checked)}
      >
        {props.children}
      </label>
    </div>
  );
};
